export { VerticalPage, type VerticalPageProps } from "./VerticalPage";
export { apiToContentItemProps } from "./apiToVerticalProps";
